export default "__VITE_ASSET__BkTmm809__"